import "./index.scss";
import { ProductCard } from "components/Product/Card"
// import { $ } from "@olmokit/dom";

/**
 * Component: CategoryProduct
 */
export function CategoryProduct() {
  console.log("CategoryProduct mounted.");

  ProductCard();
}
